export enum ItemAddType {
  ModifyTareWeight,
  Tare,
}
